import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';

const faqs = [
  {
    question: "What makes Chapter24 the safest Girls PG in Pune?",
    answer: "Safety is our absolute priority. All Chapter24 accommodations for working women feature 24/7 CCTV surveillance, biometric access control, and thoroughly background-verified staff. We provide a secure, women-only environment so you can focus entirely on your career."
  },
  {
    question: "Do you offer fully furnished PG accommodations with food?",
    answer: "Yes! Our luxury co-living spaces and premium PGs come fully furnished with high-speed Wi-Fi, power backup, modular kitchens, and regular housekeeping. Select properties also offer hygienic, nutritious meal plans tailored for working professionals."
  },
  {
    question: "Are your properties located near major IT Hubs like Hinjewadi and Kharadi?",
    answer: "Absolutely. We strategically locate our premium girls PGs near top Pune IT corridors, including Hinjewadi, Kharadi, Viman Nagar, Wakad, and PCMC. This drastically reduces your daily commute time and travel expenses."
  },
  {
    question: "Are there any brokerage fees when booking a PG with Chapter24?",
    answer: "No, Chapter24 is a zero-brokerage platform. When you book your accommodation directly through us, you save money by avoiding hefty middleman commissions. You only pay the transparent monthly rent and a standard security deposit."
  },
  {
    question: "What is the difference between traditional PGs and your Co-living spaces?",
    answer: "Unlike traditional ladies PGs that often have strict curfews and restrictive rules, Chapter24's modern co-living spaces offer professional management, standardized premium amenities, flexible access for varying work shifts, and a vibrant community of like-minded women."
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  // Generate FAQPage JSON-LD Schema for SEO
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <section className="py-20 bg-gray-50">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <div className="container-custom max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-secondary-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            Everything you need to know about finding the perfect, safe, and premium accommodation for working women in Pune.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none"
              >
                <h3 className="text-lg font-bold text-secondary-900 pr-8">{faq.question}</h3>
                <motion.div
                  animate={{ rotate: openIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="text-primary-500 flex-shrink-0"
                >
                  <FaChevronDown />
                </motion.div>
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 pb-5 pt-2 text-gray-600 leading-relaxed border-t border-gray-50">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
